import { Platform, Text, View, Image, Dimensions } from "react-native";
import { Stack } from "expo-router";

function LogoSmall() {
  if (Platform.OS === "web") {
    return <img src="/logo-main.png" alt="Dash-Hound" style={{ height: 32, objectFit: "contain" } as any} />;
  }
  return <Image source={require("../../../assets/images/logo-main.png")} style={{ height: 32, width: 120 }} resizeMode="contain" />;
}

function EventsHeader() {
  const sw = Dimensions.get("window").width - 32;
  return (
    <View style={{ flexDirection: "row", alignItems: "center", width: sw }}>
      <View style={{ width: sw / 3, alignItems: "flex-start" }}>
        <LogoSmall />
      </View>
      <View style={{ width: sw / 3, alignItems: "center" }}>
        <Text style={{ fontSize: 18, fontWeight: "700", color: "#1B2A4A" }}>Events</Text>
      </View>
      <View style={{ width: sw / 3 }} />
    </View>
  );
}

export default function EventsLayout() {
  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: "#ffffff" },
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen name="index" options={{ headerTitle: () => <EventsHeader /> }} />
      <Stack.Screen name="[id]" options={{ title: "Event Details", headerShown: false }} />
    </Stack>
  );
}
